document.addEventListener('teeinblue-event-after-cart-added', () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
        fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
        .then(res => res.json())
        .then(res => drawer.renderContents({sections: res}));
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
    }
});


function cleanTeeClipartLabelText(root) {
  (root || document).querySelectorAll('.tee-clipart-label__text.sr-only').forEach(function(el) {
    var text = (el.textContent || '').trim();
    if (!text) return;

    var nextText = text.replace(/\s+[A-Z]{3}\s*$/, '').trim();
    if (nextText !== text) {
      el.textContent = nextText;
    }
  });
}

function observeTeeClipartLabelText() {
  cleanTeeClipartLabelText();

  new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'characterData') {
        var parent = mutation.target && mutation.target.parentElement;
        if (parent && parent.matches('.tee-clipart-label__text.sr-only')) {
          cleanTeeClipartLabelText(parent.parentNode || document);
        }
        return;
      }

      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;

        if (node.matches && node.matches('.tee-clipart-label__text.sr-only')) {
          cleanTeeClipartLabelText(node.parentNode || document);
          return;
        }

        if (node.querySelector) {
          cleanTeeClipartLabelText(node);
        }
      });
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
}

observeTeeClipartLabelText();